import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import JoditEditor from "jodit-react";


export default class  AddQuestion extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,title:'',qa_id:0,categoryarray:[],category:'',rolelabel:'Select category',
      errormessage:'',erropen:false,qa_question:'',strtoken:'',
	  qa_optiona: '',
  qa_optionb: '',
  qa_optionc: '',
  qa_optiond: '',
  qa_correctans: '',
  qa_explain: '',
  qa_ex_id: ''
,examarray:[],exam:'',rolelabel1:'Select exam',  
qa_optiona_text: '',
  qa_optiona_file: null,
  qa_optionb_text: '',
  qa_optionb_file: null,
  qa_optionc_text: '',
  qa_optionc_file: null,
  qa_optiond_text: '',
  qa_optiond_file: null,qa_qimg_file: null,qa_explainimg_file: null,
 
	  }
      
  }
componentDidMount() {
  document.title = "MM Coaching Center - Question";

  if (localStorage.getItem("MMCuserid") == null) {
    this.setState({
      redirect: true,
      pagename: '/Login'
    });
    return;
  }
this.Onloadgettoken();
  this.setState({ open: true }); 



  let url = window.location.href;
  let id = this.getParameterByName('qaid', window.location.href);
if (id !== "" && id !== null && id !== "0") {
  this.setState({ qa_id: parseInt(id) }, () => {
    this.QuestiongetData(); 
  });
}

}


  
  
  getParameterByName(name, url) {
  if (!url) url = window.location.href;
  url = url.toLowerCase();
  name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

handleTextChange = (e) => {
  const { name, value } = e.target;
  this.setState({ [name]: value, [`${name.replace('_text','')}_file`]: null });
};

/*handleFileChange = (e) => {
  const { name, files } = e.target;
  if (files.length > 0) {
    this.setState({ [name]: files[0], [`${name.replace('_file','')}_text`]: '' });
  }
};*/

 Onloadgettoken()
	{
		axios.get(Serverurl+'ajaxstudentregistration.php?action=gettoken')
       .then(resp => { 		
		
			if(resp.data!=""){
				this.setState({
				strtoken:resp.data.trim(),
				}) 
			}
			
			  this.onloadcategorybind();
  this.onloadexambind();
	   })
	}
handleFileChange = (e) => {
  const { name, files } = e.target;
  if (files.length > 0) {
    const file = files[0];
    if (file.size > 512000 ) { // 500kb size check
      this.setState({
        errormessage: "File size should be less than or equal to 500 KB",
        erropen: true,
        [`${name}`]: null,
        [`${name.replace('_file','')}_text`]: ''
      });
    } else {
      this.setState({
        [`${name}`]: file,
        [`${name.replace('_file','')}_text`]: ''
      });
    }
  }
};


onloadexambind(){

    axios.get(Serverurl+'ajaxexam.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  examarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.examarray.map(exam => {
                            
          return {value: exam.ex_id, display:exam.ex_name}
        });
      
		
        this.setState({
          examarray: [{value: '', display: 'Select exam'}].concat(roleFromApi)
        });
      })


}

 onloadcategorybind(){

    axios.get(Serverurl+'ajaxcategory.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  categoryarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.categoryarray.map(category => {
                            
          return {value: category.ct_id, display:category.ct_name}
        });
      
		
        this.setState({
          categoryarray: [{value: '', display: 'Select category'}].concat(roleFromApi)
        });
      })


}
isImage = (val) => {
  return val && typeof val === 'string' && ( val.match(/\.(jpg|jpeg|png|gif)$/i));
};
clearOptionFile = (opt) => {
  this.setState({
    [`qa_${opt}_file`]: null,
    [`qa_${opt}_text`]: ''
  });
};


 handleChange = (newValue) => {
    this.setState({
      title: newValue, 
    });

  };
   handleExplainChange = (newValue) => {
    this.setState({
      qa_explain: newValue, 
    });

  };


 QuestiongetData() {
	
  if(this.state.qa_id !==0)
  {
	  
	   axios.get(Serverurl+'ajaxexam.php?action=qgetall&qa_id='+this.state.qa_id )
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      qa_id: resp.data[0].qa_id,
          title: resp.data[0].qa_question,
          /*qa_optiona: resp.data[0].qa_optiona,
          qa_optionb: resp.data[0].qa_optionb,
         qa_optionc: resp.data[0].qa_optionc,
          qa_optiond: resp.data[0].qa_optiond,*/
          qa_correctans: resp.data[0].qa_correctans,
          qa_explain: resp.data[0].qa_explain,
          exam: resp.data[0].qa_ex_id,
          category: resp.data[0].qa_ct_id, 
 
  qa_optiona_text: this.isImage(resp.data[0].qa_optiona) ? '' : resp.data[0].qa_optiona,
  qa_optiona_file: this.isImage(resp.data[0].qa_optiona) ? resp.data[0].qa_optiona : null,

  qa_optionb_text: this.isImage(resp.data[0].qa_optionb) ? '' : resp.data[0].qa_optionb,
  qa_optionb_file: this.isImage(resp.data[0].qa_optionb) ? resp.data[0].qa_optionb : null,

  qa_optionc_text: this.isImage(resp.data[0].qa_optionc) ? '' : resp.data[0].qa_optionc,
  qa_optionc_file: this.isImage(resp.data[0].qa_optionc) ? resp.data[0].qa_optionc : null,

  qa_optiond_text: this.isImage(resp.data[0].qa_optiond) ? '' : resp.data[0].qa_optiond,
  qa_optiond_file: this.isImage(resp.data[0].qa_optiond) ? resp.data[0].qa_optiond : null,

qa_qimg_file: resp.data[0].qa_qimg,
qa_explainimg_file: resp.data[0].qa_explainimg,
          
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  title:'',
	 qa_id:0,
	 qa_optiona:'',
	 qa_optionb:'',
	 qa_optionc:'',
	 qa_optiond:'',
	 qa_correctans:'',
	 qa_explain:'',
	 category:'',
	 exam:'',
	 
	  }); 
 }
  
    }



   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  title:'',qa_optionb:'',qa_optiona:'',categoryarray:[], qa_optionc:'',
	 qa_optiond:'',
	 qa_correctans:'',
	 qa_explain:'',
	 category:'',
     errormessage:'',erropen:false,
	  });
		this.QuestiongetData();
		this.onloadcategorybind();
		this.onloadexambind();


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="qa_optiona")
  {
	 // if (event.target.value === '' || re.test(event.target.value))
		  {
	  this.setState({[nam]: val}); 
	  
  }
  }
  else{
  this.setState({[nam]: val});
  }
  

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }



handleClose = (e) => {
	
 let title = this.state.title;
 
 let qa_correctans = this.state.qa_correctans;
  let category = this.state.category;
  let exam = this.state.exam;
  //let qa_explain = this.state.qa_explain;

if(exam==="")
{
	
	this.setState({errormessage:"Please select exam ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(title==="")
{
	
	this.setState({errormessage:"Please Enter the Question",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(category==="")
{
	
	this.setState({errormessage:"Please Select category",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(qa_correctans==="")
{
	
	this.setState({errormessage:"Please select correct answer ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

   var formData = new FormData();
  
  
   if(this.state.qa_id==0)
	  {
		  formData.append('qa_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('qa_id',this.state.qa_id)
		
          }
 
        formData.append('action','qinsertorupdate') 

formData.append('qa_question', this.state.title);
formData.append('qa_optiona', this.state.qa_optiona);
formData.append('qa_optionb', this.state.qa_optionb);
formData.append('qa_optionc', this.state.qa_optionc);
formData.append('qa_optiond', this.state.qa_optiond);
formData.append('qa_correctans', this.state.qa_correctans);
formData.append('qa_explain', this.state.qa_explain  || '');
formData.append('qa_ex_id', this.state.exam);
formData.append('qa_ct_id', this.state.category  || 0);

formData.append('userid', localStorage.getItem("MMCuserid"));

['optiona', 'optionb', 'optionc', 'optiond'].forEach(opt => {
  const text = this.state[`qa_${opt}_text`];
  const file = this.state[`qa_${opt}_file`];

  if (file instanceof File) {
    formData.append(`qa_${opt}`, '1');
    formData.append(`Filedata_${opt}`, file);
  } else if (typeof file === 'string' && file !== '') {
    formData.append(`qa_${opt}`, file); 
  } else {
    formData.append(`qa_${opt}`, text || '');
  }
});

const qa_qimg_file = this.state.qa_qimg_file;

if (qa_qimg_file instanceof File) {
  formData.append('qa_qimg', '1');                
  formData.append('Filedata_qaimg', qa_qimg_file);
} else if (typeof qa_qimg_file === 'string' && qa_qimg_file !== '') {
  formData.append('qa_qimg', qa_qimg_file);       
} else {
  formData.append('qa_qimg', '');                  
}

const qa_explainimg_file = this.state.qa_explainimg_file;

if (qa_explainimg_file instanceof File) {
  formData.append('qa_explainimg', '1');                
  formData.append('Filedata_explainimg', qa_explainimg_file);
} else if (typeof qa_explainimg_file === 'string' && qa_explainimg_file !== '') {
  formData.append('qa_explainimg', qa_explainimg_file);       
} else {
  formData.append('qa_explainimg', '');                  
}



		  
		axios.post(Serverurl+"ajaxexam.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
           // this.props.updateDonenew();
    
        });
  
	
	//this.setState({ open:false });
	window.location.href = "/#/Questions";

};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>
  <div className="containermain">
    <div className="boxheading">
      <div className="contntpad">
        <h2>Question</h2>
      </div>
    </div>

    <Box p={3}>
      <Collapse in={this.state.erropen}>
        <Alert severity="error" action={
          <IconButton aria-label="close" color="inherit" size="small" onClick={this.handleErrorclose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }>
          {this.state.errormessage}
        </Alert>
      </Collapse>
	  
	   <ul className="ques-list">
  <li>
    <p><span className="validation">*</span> Exam</p>
    <FormControl fullWidth variant="outlined" margin="normal">
      <Select
        native
        value={this.state.exam}
        onChange={this.myChangeHandler}
        name="exam"
        id="exam"
      >
        {this.state.examarray.map(exam => (
          <option key={exam.value} value={exam.value}>
            {exam.display}
          </option>
        ))}
      </Select>
    </FormControl>
  </li>

  <li>
    <p><span className="validation">*</span> Category</p>
    <FormControl fullWidth variant="outlined" margin="normal">
      <Select
        native
        value={this.state.category}
        onChange={this.myChangeHandler}
        name="category"
        id="category"
      >
        {this.state.categoryarray.map(category => (
          <option key={category.value} value={category.value}>
            {category.display}
          </option>
        ))}
      </Select>
    </FormControl>
  </li>

<li>
  <p><span className="validation">*</span> Question</p>
  <JoditEditor
    ref={this.editor}
    value={this.state.title}
    tabIndex={1}
    onChange={this.handleChange}
  />
</li>

<li>
  <p>Question image</p>
  <input
    type="file"
    name="qa_qimg_file"
    accept="image/*"
    onChange={this.handleFileChange}
  />
  
  
  {this.state.qa_qimg_file && (
    <div style={{ marginTop: 10 }}>
      <img
  src={
    typeof this.state.qa_qimg_file === 'string'
      ? 'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_qimg_file + '?Authorization='+this.state.strtoken  
      : this.state.qa_qimg_file
      ? URL.createObjectURL(this.state.qa_qimg_file)
      : ''
  }
  alt="Question Image"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.setState({ qa_qimg_file: null })}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>

<li>
  <p><span className="validation">*</span> Option A</p>

  
  <TextField
    name="qa_optiona_text"
    onChange={this.handleTextChange}
    fullWidth
    value={this.state.qa_optiona_text}
    disabled={!!this.state.qa_optiona_file}
    inputProps={{ maxLength: 250 }}
  />

  
  <input
    type="file"
    name="qa_optiona_file"
    accept="image/*"
    onChange={this.handleFileChange}
    disabled={!!this.state.qa_optiona_text}
  />

  
  {this.state.qa_optiona_file && (
    <div style={{ marginTop: 10 }}>
      
      <img
  src={
    typeof this.state.qa_optiona_file === 'string'
      ? 'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_optiona_file + '?Authorization='+this.state.strtoken  
      : this.state.qa_optiona_file                           
      ? URL.createObjectURL(this.state.qa_optiona_file)
      : ''
  }
  alt="Option A"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>


      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.clearOptionFile('optiona')}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>



  <li>
  <p><span className="validation">*</span> Option B</p>

  
  <TextField
    name="qa_optionb_text"
    onChange={this.handleTextChange}
    fullWidth
    value={this.state.qa_optionb_text}
    disabled={!!this.state.qa_optionb_file}
    inputProps={{ maxLength: 250 }}
  />

  
  <input
    type="file"
    name="qa_optionb_file"
    accept="image/*"
    onChange={this.handleFileChange}
    disabled={!!this.state.qa_optionb_text}
  />

  
  {this.state.qa_optionb_file && (
    <div style={{ marginTop: 10 }}>
      
     <img
  src={
    typeof this.state.qa_optionb_file === 'string'
      ? 'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_optionb_file + '?Authorization='+this.state.strtoken 
      : this.state.qa_optionb_file                           
      ? URL.createObjectURL(this.state.qa_optionb_file)
      : ''
  }
  alt="Option A"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>

      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.clearOptionFile('optionb')}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>


  <li>
  <p><span className="validation">*</span> Option C</p>

  
  <TextField
    name="qa_optionc_text"
    onChange={this.handleTextChange}
    fullWidth
    value={this.state.qa_optionc_text}
    disabled={!!this.state.qa_optionc_file}
    inputProps={{ maxLength: 250 }}
  />

  
  <input
    type="file"
    name="qa_optionc_file"
    accept="image/*"
    onChange={this.handleFileChange}
    disabled={!!this.state.qa_optionc_text}
  />

  
  {this.state.qa_optionc_file && (
    <div style={{ marginTop: 10 }}>
      
      <img
  src={
    typeof this.state.qa_optionc_file === 'string'
      ?  'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_optionc_file + '?Authorization='+this.state.strtoken  
      : this.state.qa_optionc_file                           
      ? URL.createObjectURL(this.state.qa_optionc_file)
      : ''
  }
  alt="Option A"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>

      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.clearOptionFile('optionc')}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>


  <li>
  <p><span className="validation">*</span> Option D</p>

  
  <TextField
    name="qa_optiond_text"
    onChange={this.handleTextChange}
    fullWidth
    value={this.state.qa_optiond_text}
    disabled={!!this.state.qa_optiond_file}
    inputProps={{ maxLength: 250 }}
  />

  
  <input
    type="file"
    name="qa_optiond_file"
    accept="image/*"
    onChange={this.handleFileChange}
    disabled={!!this.state.qa_optiond_text}
  />

  
  {this.state.qa_optiond_file && (
    <div style={{ marginTop: 10 }}>
      
      <img
  src={
    typeof this.state.qa_optiond_file === 'string'
      ?  'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_optiond_file + '?Authorization='+this.state.strtoken  
      : this.state.qa_optiond_file                           
      ? URL.createObjectURL(this.state.qa_optiond_file)
      : ''
  }
  alt="Option A"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>

      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.clearOptionFile('optiond')}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>


  <li>
    <p><span className="validation">*</span> Correct Answer</p>
    <FormControl fullWidth variant="outlined" margin="normal">
      <Select
        native
        name="qa_correctans"
        value={this.state.qa_correctans}
        onChange={this.myChangeHandler}
        id="qa_correctans"
      >
        <option value="">Select Correct Answer</option>
        <option value="1">Option A</option>
        <option value="2">Option B</option>
        <option value="3">Option C</option>
        <option value="4">Option D</option>
      </Select>
    </FormControl>
  </li>
<li>
 <p><span className="validation">*</span>Explain</p>
<JoditEditor
ref={this.editor} 
  value={this.state.qa_explain}
  tabIndex={2}
  onChange={this.handleExplainChange}
/>
</li>

<li>
  <p>Explanation image</p>
  <input
    type="file"
    name="qa_explainimg_file"
    accept="image/*"
    onChange={this.handleFileChange}
  />
  
  
  {this.state.qa_explainimg_file && (
    <div style={{ marginTop: 10 }}>
      <img
  src={
    typeof this.state.qa_explainimg_file === 'string'
      ?   'https://f003.backblazeb2.com/file/mmcoaching/' + this.state.qa_explainimg_file + '?Authorization='+this.state.strtoken 
      : this.state.qa_explainimg_file
      ? URL.createObjectURL(this.state.qa_explainimg_file)
      : ''
  }
  alt="Explain Image"
  style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ccc' }}
/>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => this.setState({ qa_explainimg_file: null })}
        style={{ display: 'block', marginTop: 10 }}
      >
        Remove Image
      </Button>
    </div>
  )}
</li>

</ul>

      <Box mt={3} display="flex" justifyContent="flex-start" gap={2}>
        <Button variant="contained" className="admsndisablebtn" onClick={() => window.location.href = "/#/Questions"}>
          Cancel
        </Button>
        <Button variant="contained" className="frmPrimarybtn" onClick={this.handleClose}>
          Save
        </Button>
      </Box>
    </Box>
  </div>
</React.Fragment>


) }
 
} 
  